export default __webpack_public_path__ + "static/logo-dbe50b86d21c63a4a4136f5c5516eae5.svg";